import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import FormControl from '@material-ui/core/FormControl'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import moment from 'moment'
import ProfileHelper from 'helpers/profile'

class EventResultDateInput extends Component {
  constructor(props) {
    super(props)
    this.dateRangeChange = false
    this.state = {
      evt_logbook_id: props.eventInfo.evt_logbook_id,
      previousValue: props.eventInfo.previous_value,
      value: props.eventInfo.value ? moment(props.eventInfo.value) : '',
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.eventInfo !== nextProps.eventInfo) {
      this.setState({
        evt_logbook_id: nextProps.eventInfo.evt_logbook_id,
        previousValue: nextProps.eventInfo.previous_value,
        value: nextProps.eventInfo.value
          ? moment(nextProps.eventInfo.value)
          : '',
      })

      return false
    }

    return true
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onDateChange = value => {
    if (!this.dateRangeChange && value) {
      this.setState(
        {
          value: moment(value),
        },
        () => {
          this.props.onValueChange({
            ...this.props.eventInfo,
            value: this.state.value.utc().format('YYYY-MM-DD'),
            evt_logbook_id: this.state.evt_logbook_id,
            setResultId: this.setResultId,
          })
        },
      )
      this.dateRangeChange = true
    } else {
      this.dateRangeChange = false
    }
  }

  render() {
    const { value, previousValue } = this.state
    const { disabled } = this.props
    const checkValue = !value ? null : value
    const locale = ProfileHelper.getCurrentLocale()
    const checkPreviousValue = !previousValue
      ? ''
      : moment(previousValue, 'YYYY-MM-DD').format('DD/MM/YYYY')

    return (
      <FormControl className="event-result-field event-result-input">
        {Boolean(!checkValue) && (
          <span className="select-placeholder">{checkPreviousValue}</span>
        )}
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={locale}>
          <DatePicker
            fullWidth
            autoOk
            disableToolbar
            disableFuture
            allowKeyboardControl={false}
            disabled={disabled}
            variant="inline"
            format="dd/MM/yyyy"
            value={checkValue}
            onChange={this.onDateChange}
          />
        </MuiPickersUtilsProvider>
      </FormControl>
    )
  }
}

export default injectIntl(EventResultDateInput)
